export interface Movie {
  id: number;
  title: string;
  originalTitle: string;
  category: string;
  categorySlug: string;
  rating: number;
  year: number;
  region: string;
  duration: string;
  director: string;
  actors: string[];
  description: string;
  coverImage: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
}

export const categories = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-movie-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '电视剧', slug: 'tvseries', icon: 'ri-tv-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    originalTitle: 'The Wandering Earth 3',
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    year: 2026,
    region: '中国大陆',
    duration: '148分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。本作延续前作宏大的宇宙叙事，人类文明在浩瀚星空中寻找新的希望，面临前所未有的挑战与抉择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%20with%20astronaut%20in%20space%20facing%20massive%20planet%2C%20dramatic%20lighting%2C%20dark%20cosmic%20background%20with%20stars%2C%20cinematic%20composition%2C%20warm%20golden%20accent%20lights%2C%20clean%20minimal%20design&width=600&height=840&seq=movie-cover-01&orientation=portrait',
    tags: ['热门', '高分', 'IMAX'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-28 更新至高清版',
  },
  {
    id: 2,
    title: '封神第二部',
    originalTitle: 'Creation of the Gods II',
    category: '动作片',
    categorySlug: 'action',
    rating: 8.8,
    year: 2026,
    region: '中国大陆',
    duration: '155分钟',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    description: '商朝末年，纣王暴虐，天下大乱。姬发率领西岐大军反抗暴政，姜子牙携封神榜下山辅佐。一场关于天命与人心、正义与邪恶的史诗大战即将拉开帷幕。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20warrior%20movie%20poster%2C%20golden%20armor%20and%20flowing%20red%20cape%2C%20dramatic%20battle%20scene%20silhouette%2C%20mystical%20atmosphere%2C%20dark%20background%20with%20golden%20accents%2C%20epic%20cinematic%20style&width=600&height=840&seq=movie-cover-02&orientation=portrait',
    tags: ['热门', '神话', '史诗'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-25 更新至高清版',
  },
  {
    id: 3,
    title: '长安的荔枝',
    originalTitle: 'The Lychee of Chang\'an',
    category: '爱情片',
    categorySlug: 'romance',
    rating: 8.5,
    year: 2026,
    region: '中国大陆',
    duration: '132分钟',
    director: '陈凯歌',
    actors: ['易烊千玺', '周冬雨', '雷佳音'],
    description: '盛唐天宝年间，长安城内一段关于荔枝与爱情的传奇故事。小吏李善德奉命从岭南运送新鲜荔枝至长安，一路上历经艰险，也收获了真挚的感情。影片展现了盛唐气象与小人物的动人故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20historical%20film%20poster%2C%20Tang%20dynasty%20aesthetic%2C%20elegant%20couple%20in%20traditional%20robes%20with%20lychee%20fruits%2C%20soft%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20cinematic%20composition&width=600&height=840&seq=movie-cover-03&orientation=portrait',
    tags: ['推荐', '爱情', '古装'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-20 更新至超清版',
  },
  {
    id: 4,
    title: '哪吒之魔童闹海',
    originalTitle: 'Nezha: The Devil\'s Roar',
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.5,
    year: 2026,
    region: '中国大陆',
    duration: '125分钟',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '张珈铭'],
    description: '天劫之后，哪吒和敖丙的灵魂虽被保住，但肉身危在旦夕。太乙真人打算用七色宝莲为二人重塑肉身，然而过程中却遭遇重重困难。哪吒将面临更加严峻的考验，在命运与自我之间做出抉择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20mythological%20boy%20warrior%20with%20fire%20powers%2C%20dragon%20motif%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20pose%2C%20celestial%20background%2C%20cinematic%20lighting&width=600&height=840&seq=movie-cover-04&orientation=portrait',
    tags: ['热门', '高分', '国漫'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-30 更新至高清版',
  },
  {
    id: 5,
    title: '抓娃娃',
    originalTitle: 'Successor',
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.2,
    year: 2026,
    region: '中国大陆',
    duration: '118分钟',
    director: '闫非',
    actors: ['沈腾', '马丽', '魏翔'],
    description: '一对富有的夫妻为了培养孩子，假装成穷人在破旧大院里生活，对孩子进行"吃苦教育"。荒诞又温情的喜剧故事，笑中带泪，反思当代家庭教育中的种种问题。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20funny%20family%20scene%20with%20parents%20and%20child%20in%20simple%20courtyard%20home%2C%20warm%20natural%20lighting%2C%20heartwarming%20atmosphere%2C%20bright%20cheerful%20tone%2C%20cinematic%20composition&width=600&height=840&seq=movie-cover-05&orientation=portrait',
    tags: ['热门', '喜剧', '家庭'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-18 更新至超清版',
  },
  {
    id: 6,
    title: '周处除三害',
    originalTitle: 'The Pig, the Snake and the Pigeon',
    category: '动作片',
    categorySlug: 'action',
    rating: 8.7,
    year: 2026,
    region: '中国台湾',
    duration: '134分钟',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文'],
    description: '通缉犯陈桂林身患绝症，决定在生命最后时刻除掉排名在自己前面的两大通缉犯，以此留名。一场疯狂又荒诞的除害之旅就此展开，动作场面惊心动魄，引人深思。',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20action%20thriller%20movie%20poster%2C%20lone%20man%20silhouette%20against%20urban%20night%2C%20neon%20accents%2C%20gritty%20atmosphere%2C%20intense%20mood%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20deep%20shadows&width=600&height=840&seq=movie-cover-06&orientation=portrait',
    tags: ['推荐', '犯罪', '动作'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-07-22 更新至高清版',
  },
  {
    id: 7,
    title: '热辣滚烫',
    originalTitle: 'YOLO',
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.3,
    year: 2026,
    region: '中国大陆',
    duration: '129分钟',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    description: '一个善良的女孩在经历生活的种种打击后，决定通过拳击改变自己。她从一个不自信的胖女孩，蜕变为勇敢面对生活的战士，用汗水与坚持重新找回自我价值。',
    coverImage: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20comedy-drama%20movie%20poster%2C%20woman%20boxing%20gloves%20determined%20expression%2C%20warm%20motivational%20lighting%2C%20gym%20atmosphere%2C%20soft%20golden%20and%20pink%20tones%2C%20cinematic%20portrait%20style&width=600&height=840&seq=movie-cover-07&orientation=portrait',
    tags: ['推荐', '励志', '喜剧'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-15 更新至超清版',
  },
  {
    id: 8,
    title: '三体：黑暗森林',
    originalTitle: 'Three-Body: The Dark Forest',
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.0,
    year: 2026,
    region: '中国大陆',
    duration: '160分钟',
    director: '张艺谋',
    actors: ['刘德华', '吴京', '张译'],
    description: '基于刘慈欣科幻巨著改编，三体舰队正向地球驶来，人类面临前所未有的生存危机。面壁计划启动，四位面壁者与三体世界展开一场跨越星际的智力对决，宇宙的黑暗森林法则逐渐揭示。',
    coverImage: 'https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20movie%20poster%2C%20abstract%20cosmic%20geometry%20with%20dark%20forest%20silhouette%2C%20mysterious%20universe%20atmosphere%2C%20deep%20space%20vibes%2C%20minimalist%20yet%20epic%20composition%2C%20warm%20amber%20highlights%20on%20dark%20background&width=600&height=840&seq=movie-cover-08&orientation=portrait',
    tags: ['热门', '高分', '科幻'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-08-01 更新至高清版',
  },
  {
    id: 9,
    title: '长安三万里',
    originalTitle: 'Chang\'an',
    category: '动画片',
    categorySlug: 'animation',
    rating: 8.9,
    year: 2026,
    region: '中国大陆',
    duration: '168分钟',
    director: '谢君伟',
    actors: ['杨天翔', '陈张太康', '姜广涛'],
    description: '安史之乱后，吐蕃大军攻打大唐，大唐节度使高适回忆起与李白的一生往事。影片以诗意为笔，描绘了大唐盛世下诗人们的豪情壮志与人生际遇，重现长安城的繁华与壮美。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20epic%20poster%2C%20ancient%20Tang%20dynasty%20cityscape%20with%20poets%20in%20traditional%20robes%2C%20warm%20golden%20sunset%20lighting%2C%20ink%20painting%20aesthetic%2C%20cinematic%20beauty&width=600&height=840&seq=movie-cover-09&orientation=portrait',
    tags: ['推荐', '国漫', '历史'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-10 更新至超清版',
  },
  {
    id: 10,
    title: '巨齿鲨2：深渊',
    originalTitle: 'Meg 2: The Trench',
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 7.8,
    year: 2026,
    region: '美国',
    duration: '119分钟',
    director: '本·维特利',
    actors: ['杰森·斯坦森', '吴京', '蔡书雅'],
    description: '乔纳斯·泰勒带领科研团队潜入深海7000米，遭遇巨齿鲨群和更多未知的史前海洋生物。在暗无天日的深渊中，人类与远古巨兽展开一场惊心动魄的生死对决。',
    coverImage: 'https://readdy.ai/api/search-image?query=Thrilling%20monster%20movie%20poster%2C%20giant%20shark%20silhouette%20in%20deep%20ocean%2C%20divers%20descending%20into%20dark%20abyss%2C%20tense%20atmosphere%2C%20dramatic%20underwater%20lighting%2C%20cinematic%20action%20style&width=600&height=840&seq=movie-cover-10&orientation=portrait',
    tags: ['推荐', '惊悚', '冒险'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-07-27 更新至高清版',
  },
  {
    id: 11,
    title: '志愿军：存亡之战',
    originalTitle: 'The Volunteers: Battle of Life and Death',
    category: '动作片',
    categorySlug: 'action',
    rating: 9.1,
    year: 2026,
    region: '中国大陆',
    duration: '150分钟',
    director: '陈凯歌',
    actors: ['张译', '吴京', '段奕宏'],
    description: '抗美援朝战争中的一场关键战役，志愿军战士们在极端恶劣的条件下，以钢铁般的意志和血肉之躯，与装备精良的敌军展开殊死搏斗，谱写了一曲可歌可泣的英雄赞歌。',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20war%20film%20poster%2C%20soldiers%20in%20battle%20silhouette%20against%20burning%20sky%2C%20dramatic%20smoke%20and%20fire%2C%20heroic%20atmosphere%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20cinematic%20composition&width=600&height=840&seq=movie-cover-11&orientation=portrait',
    tags: ['热门', '战争', '历史'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-12 更新至超清版',
  },
  {
    id: 12,
    title: '一闪一闪亮星星',
    originalTitle: 'Twinkling Stars',
    category: '爱情片',
    categorySlug: 'romance',
    rating: 8.0,
    year: 2026,
    region: '中国大陆',
    duration: '110分钟',
    director: '陈小明',
    actors: ['屈楚萧', '张佳宁', '傅菁'],
    description: '一部关于青春、暗恋与时空穿越的浪漫爱情故事。林北星在一次次穿越中，试图改变过去，拯救心爱的人。影片以细腻的情感描绘了跨越时空的深情与守候。',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20film%20poster%2C%20young%20couple%20under%20starry%20night%20sky%2C%20dreamy%20soft%20lighting%2C%20nostalgic%20school%20background%2C%20gentle%20pink%20and%20blue%20twilight%20tones%2C%20cinematic%20portrait&width=600&height=840&seq=movie-cover-12&orientation=portrait',
    tags: ['推荐', '青春', '爱情'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-08 更新至超清版',
  },
  {
    id: 13,
    title: '庆余年第二季',
    originalTitle: 'Joy of Life Season 2',
    category: '电视剧',
    categorySlug: 'tvseries',
    rating: 9.3,
    year: 2026,
    region: '中国大陆',
    duration: '全36集',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势。各方势力暗流涌动，范闲在权力与情感的漩涡中步步为营。第二季延续了第一季的精彩剧情，制作更加精良，剧情更加扣人心弦。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20handsome%20man%20in%20traditional%20royal%20robes%2C%20palace%20background%2C%20intricate%20details%2C%20warm%20golden%20lighting%2C%20elegant%20cinematic%20composition&width=600&height=840&seq=movie-cover-13&orientation=portrait',
    tags: ['热门', '高分', '古装'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-29 更新至全36集',
  },
  {
    id: 14,
    title: '狂飙',
    originalTitle: 'The Knockout',
    category: '电视剧',
    categorySlug: 'tvseries',
    rating: 9.4,
    year: 2026,
    region: '中国大陆',
    duration: '全39集',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    description: '一部展现扫黑除恶斗争的电视剧。以刑警安欣与黑恶势力长达二十年的生死较量为主线，深刻描绘了正义与邪恶的激烈对抗，以及人性的复杂与变化。剧情扣人心弦，演技炸裂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20TV%20drama%20poster%2C%20two%20men%20facing%20off%20in%20dark%20alley%2C%20neon%20lights%2C%20intense%20urban%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20cinematic%20composition&width=600&height=840&seq=movie-cover-14&orientation=portrait',
    tags: ['热门', '高分', '犯罪'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-06-30 更新至全39集',
  },
  {
    id: 15,
    title: '大江大河3',
    originalTitle: 'Like a Flowing River 3',
    category: '电视剧',
    categorySlug: 'tvseries',
    rating: 9.0,
    year: 2026,
    region: '中国大陆',
    duration: '全40集',
    director: '孔笙',
    actors: ['王凯', '杨烁', '董子健'],
    description: '延续前作时间线，讲述改革开放大潮中，宋运辉、雷东宝、杨巡三人在新时代背景下的奋斗历程。他们各自在国企改革、乡镇企业和个体经济领域继续书写着属于自己的传奇。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%20three%20men%20in%201990s%20Chinese%20style%20clothing%2C%20industrial%20background%2C%20warm%20nostalgic%20tone%2C%20soft%20golden%20lighting%2C%20cinematic%20group%20portrait&width=600&height=840&seq=movie-cover-15&orientation=portrait',
    tags: ['推荐', '年代', '励志'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-06-25 更新至全40集',
  },
  {
    id: 16,
    title: '隐秘的角落',
    originalTitle: 'The Bad Kids',
    category: '电视剧',
    categorySlug: 'tvseries',
    rating: 9.1,
    year: 2026,
    region: '中国大陆',
    duration: '全12集',
    director: '辛爽',
    actors: ['秦昊', '王景春', '荣梓杉'],
    description: '三个孩子在景区游玩时，无意间拍摄到一起谋杀案。从此，他们的命运与凶手纠缠在一起，一场关于善与恶、真相与谎言的博弈在隐秘的角落悄然展开。悬疑丛生，引人入胜。',
    coverImage: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20Chinese%20drama%20poster%2C%20three%20children%20looking%20at%20camera%20in%20dark%20setting%2C%20eerie%20mountain%20landscape%2C%20mysterious%20mood%2C%20cold%20and%20warm%20contrast%20lighting%2C%20cinematic%20style&width=600&height=840&seq=movie-cover-16&orientation=portrait',
    tags: ['推荐', '悬疑', '高分'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-07-23 更新至全12集',
  },
];

export const hotTags = ['流浪地球3', '封神', '哪吒', '庆余年', '狂飙', '三体', '科幻大片', '国漫崛起', '高分推荐', '最新上映'];

export const siteInfo = {
  name: '丫丫影院',
  slogan: '免费高清影视在线观看，不缓冲最新电影电视剧全集',
  description: '丫丫影院是一个专业的免费高清影视在线观看平台，致力于为广大影迷提供最新、最全、最高清的电影和电视剧资源。我们拥有丰富的片库，涵盖动作、喜剧、爱情、科幻、恐怖、动画、纪录片等多种类型，以及最新的热门电视剧。所有资源均支持流畅播放，无需缓冲等待，让您享受极致的观影体验。',
  email: 'contact@yayacinema.com',
  phone: '400-888-9999',
  copyright: '© 2026 丫丫影院 版权所有',
};